function getRuntimeApiBaseUrl() {
  const configuredBaseUrl = String(process.env.REACT_APP_API_URL || "")
    .trim()
    .replace(/\/+$/, "");

  if (typeof window === "undefined") {
    return configuredBaseUrl || "http://localhost:4000";
  }

  const isClientLocalhost = ["localhost", "127.0.0.1", "::1"].includes(
    window.location.hostname,
  );

  // In production, default to same-origin API when env is missing.
  if (!configuredBaseUrl) {
    return isClientLocalhost
      ? "http://localhost:4000"
      : window.location.origin.replace(/\/+$/, "");
  }

  try {
    const configuredUrl = new URL(configuredBaseUrl);
    const isConfiguredLocalhost = ["localhost", "127.0.0.1"].includes(
      configuredUrl.hostname,
    );

    // Useful for phone testing on LAN when .env still points to localhost.
    if (isConfiguredLocalhost && !isClientLocalhost) {
      configuredUrl.hostname = window.location.hostname;
      if (window.location.protocol === "https:") {
        configuredUrl.protocol = "https:";
      }
      return configuredUrl.toString().replace(/\/+$/, "");
    }
  } catch (_error) {
    // Keep configured URL if parsing fails.
  }

  return configuredBaseUrl;
}

const API_BASE_URL = getRuntimeApiBaseUrl();

function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

async function readResponsePayload(response) {
  const contentType = response.headers.get("content-type") || "";
  const rawText = await response.text();

  if (contentType.includes("application/json")) {
    if (!rawText.trim()) {
      return null;
    }

    try {
      return JSON.parse(rawText);
    } catch (_error) {
      const error = new Error("Invalid JSON response from server.");
      error.status = response.status;
      error.payload = rawText;
      throw error;
    }
  }

  return rawText;
}

export async function apiRequest(path, options = {}) {
  const {
    method = "GET",
    body,
    headers = {},
    credentials = "include",
  } = options;

  const response = await fetch(buildApiUrl(path), {
    method,
    credentials,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const payload = await readResponsePayload(response);

  if (!response.ok) {
    const responseSummary =
      typeof payload === "string"
        ? payload.trim().slice(0, 140)
        : "";
    const error = new Error(
      (payload && typeof payload === "object" && payload?.error) ||
        responseSummary ||
        `HTTP ${response.status}`,
    );
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export { API_BASE_URL, readResponsePayload };
